module.exports = __webpack_public_path__ + "logo.png?ffd248bd463ec7bb15fd77f4dcecc1a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 17
// module chunks = 0